import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const features = ['10 recetas rescate en 15 min + explicaciones técnicas', 'Ingredientes 100% argentinos', 'Pasos cronometrados (0–5 / 5–15)', 'Variaciones por lo que tenés', 'Tips de vianda incluidos', 'Formato PDF mobile-first'];
export function ProductSection() {
  return <section className="w-full py-10 md:py-12 px-6 bg-gradient-to-b from-cream to-rose-50" data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="bg-rose-50/50 rounded-3xl p-6 md:p-10 shadow-warm-lg border border-rose-200/30" data-id="element-100">
          <span className="inline-block px-4 py-2 mb-4 text-sm font-semibold text-orange bg-orange/10 rounded-full" data-id="element-101">
            📗 PRODUCTO PRINCIPAL
          </span>

          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brown-dark mb-2" data-id="element-102">
            Recetas Rescate
          </h2>

          <p className="font-heading text-lg md:text-xl text-orange font-medium mb-6" data-id="element-103">
            Soluciones de 15 Minutos para Mamás Ocupadas
          </p>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="mb-6 -mx-2" data-id="element-104">
            <img src="https://cdn.magicpatterns.com/uploads/dMMeibqUYtKV6uHTpcvMLW/mama_expres_foto_2.png" alt="Manos cortando tomates frescos sobre tabla de madera con sartén humeante de fondo" className="w-full rounded-2xl object-cover aspect-[16/9]" data-id="element-105" />
          </motion.div>

          <div className="space-y-3" data-id="element-106">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.08
          }} className="flex items-center gap-4" data-id="element-107">
                <div className="flex-shrink-0 w-7 h-7 bg-green rounded-full flex items-center justify-center" data-id="element-108">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-109" />
                </div>
                <p className="font-body text-brown-dark text-lg" data-id="element-110">{feature}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}